"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _modal["default"];
  }
});
var _modal = _interopRequireDefault(require("./modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }